import { API_BASE_URL } from '../config';
// d
class NovoEventoService {
    constructor(){
        this.state = {
          
            url: `${API_BASE_URL}/core/registro_corrida/`,
            url9: `${API_BASE_URL}/core/inscricoes/new_voucher/`,
            url6: `${API_BASE_URL}/core/registro_corrida/retrieve_eventos`,
            url2: `${API_BASE_URL}/core/registro_corrida/retrieve_evento/`,
            url5: `${API_BASE_URL}/core/registro_corrida/upload_folder/`,
            url3: `${API_BASE_URL}/core/categoria-corrida/`,
            url4: `${API_BASE_URL}/core/registro_corrida/retrieve_categoria_corrida/`,
            url7: `${API_BASE_URL}/core/registro_corrida/dash_organizador/`,
            url8: `${API_BASE_URL}/core/fin/`,
            url10 : `${API_BASE_URL}/core/registro_corrida/corridas_ativas`,
            urlRegulamento: `${API_BASE_URL}/core/registro_corrida/upload_regulamento/`,
            urlLotes: `${API_BASE_URL}/core/lotes/`,
        };
    }

    setNovoLote(data){
        return fetch(this.state.urlLotes, {
            method: 'POST',
            body: typeof data === 'string' ? data : JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': 'Token ' + sessionStorage.getItem('brv-user-token')
            }
        });
    };

    getLotesPorCorrida(idCorrida){
        return fetch(`${this.state.urlLotes}corrida/${idCorrida}/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': 'Token ' + sessionStorage.getItem('brv-user-token')
            }
        });
    };

    updateLote(idLote, data){
        return fetch(`${this.state.urlLotes}${idLote}/`, {
            method: 'PATCH',
            body: typeof data === 'string' ? data : JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': 'Token ' + sessionStorage.getItem('brv-user-token')
            }
        });
    };

    toggleAtivoLote(idLote, ativo){
        return this.updateLote(idLote, { ativo: ativo });
    };

    deleteLote(idLote){
        return fetch(`${this.state.urlLotes}${idLote}/`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': 'Token ' + sessionStorage.getItem('brv-user-token')
            }
        });
    };

    setNovoEvento(data){
        return fetch(this.state.url, {method:'POST', body:data, headers:{'Content-Type': 'application/json; charset=UTF-8','Authorization':'Token '+sessionStorage.getItem('brv-user-token')}});
    };

    setNovoVoucher(data){
        return fetch(this.state.url9, {method:'POST', body:data, headers:{'Content-Type': 'application/json; charset=UTF-8','Authorization':'Token '+sessionStorage.getItem('brv-user-token')}});
    };

    setFolderCorrida(data){
        return fetch(this.state.url5, {method:'POST', body:data, headers:{'Authorization':'Token '+sessionStorage.getItem('brv-user-token')}});
    };

    setRegulamentoCorrida(data){
        return fetch(this.state.urlRegulamento, {method:'POST', body:data, headers:{'Authorization':'Token '+sessionStorage.getItem('brv-user-token')}});
    };

    getEventoPorOrganizador(id){
        return fetch(this.state.url2+id, {method:'GET',  headers:{'Content-Type': 'application/json; charset=UTF-8','Authorization':'Token '+sessionStorage.getItem('brv-user-token')}});
    };

    getFinanceiroCorrida(data){
        return fetch(this.state.url8+data, {method:'GET', headers:{'Content-Type': 'application/json; charset=UTF-8','Authorization':'Token '+sessionStorage.getItem('brv-user-token')}});
    };

    geCategoriaPorCorrida(id){
        return fetch(this.state.url4+id, {method:'GET',  headers:{'Content-Type': 'application/json; charset=UTF-8','Authorization':'Token '+sessionStorage.getItem('brv-user-token')}});
    };

    getTodosEventos(){
        return fetch(this.state.url6, {method:'GET',  headers:{'Content-Type': 'application/json; charset=UTF-8','Authorization':'Token '+sessionStorage.getItem('brv-user-token')}});
    };

    setCategoriasEvento(data){
        return fetch(this.state.url3, {method:'POST', body:data, headers:{'Content-Type': 'application/json; charset=UTF-8','Authorization':'Token '+sessionStorage.getItem('brv-user-token')}});
    };

    updateCategoria(id, data){
        const body = typeof data === 'string' ? data : JSON.stringify(data);
        return fetch(`${this.state.url3}${id}/`, {
            method: 'PATCH',
            body: body,
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': 'Token ' + sessionStorage.getItem('brv-user-token')
            }
        });
    };

    deleteCategoria(id){
        return fetch(`${this.state.url3}${id}/`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': 'Token ' + sessionStorage.getItem('brv-user-token')
            }
        });
    };

    deleteEvento(id){
        return fetch(`${this.state.url}${id}/`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': 'Token ' + sessionStorage.getItem('brv-user-token')
            }
        });
    };

    setUpdateStatusEvento(data,id){
        return fetch(this.state.url+id+'/', {method:'PATCH', body:data, headers:{'Content-Type': 'application/json; charset=UTF-8','Authorization':'Token '+sessionStorage.getItem('brv-user-token')}});
    };

    patchEvento(id, data){
        const body = typeof data === 'string' ? data : JSON.stringify(data);
        return fetch(this.state.url+id+'/', {
            method: 'PATCH',
            body: body,
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': 'Token ' + sessionStorage.getItem('brv-user-token')
            }
        });
    };

    patchFolderCorrida(id, formData) {
        return fetch(this.state.url5, {
            method: 'POST',
            body: formData,
            headers: {
                'Authorization': 'Token ' + sessionStorage.getItem('brv-user-token')
            }
        });
    };

    updateRegistroCorrida(data, id){
        return fetch(this.state.url+id+'/', {method:'PUT', body:data, headers:{'Content-Type': 'application/json; charset=UTF-8','Authorization':'Token '+sessionStorage.getItem('brv-user-token')}});
    };

    getDashOrganizador(id){
        return fetch(this.state.url7+id, {method:'GET',  headers:{'Content-Type': 'application/json; charset=UTF-8','Authorization':'Token '+sessionStorage.getItem('brv-user-token')}});
    };

    getCorridasPublico(){
        return fetch(this.state.url10, {method:'GET',  headers:{'Content-Type': 'application/json; charset=UTF-8'}});
    }

    dispararEmailMassa(idCorrida, data){
        return fetch(`${this.state.url}${idCorrida}/disparo_email/`, {
            method: 'POST',
            body: data,
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': 'Token ' + sessionStorage.getItem('brv-user-token')
            }
        });
    }

    getCoOrganizadores(idCorrida){
        return fetch(`${this.state.url}${idCorrida}/co-organizadores/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': 'Token ' + sessionStorage.getItem('brv-user-token')
            }
        });
    }

    adicionarCoOrganizador(idCorrida, email){
        return fetch(`${this.state.url}${idCorrida}/co-organizadores/`, {
            method: 'POST',
            body: JSON.stringify({ email: email }),
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': 'Token ' + sessionStorage.getItem('brv-user-token')
            }
        });
    }

    removerCoOrganizador(idCorrida, idUsuario){
        return fetch(`${this.state.url}${idCorrida}/co-organizadores/${idUsuario}/`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': 'Token ' + sessionStorage.getItem('brv-user-token')
            }
        });
    }

    uploadTrajeto(idCorrida, formData){
        const token = sessionStorage.getItem('brv-user-token') || localStorage.getItem('token') || '';
        return fetch(`${this.state.url}${idCorrida}/trajeto/`, {
            method: 'POST',
            body: formData,
            headers: {
                ...(token ? { 'Authorization': 'Token ' + token } : {})
            }
        });
    }

    getTrajeto(idCorrida){
        const token = sessionStorage.getItem('brv-user-token') || localStorage.getItem('token') || '';
        return fetch(`${this.state.url}${idCorrida}/trajeto/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                ...(token ? { 'Authorization': 'Token ' + token } : {})
            }
        });
    }

    removerTrajeto(idCorrida){
        const token = sessionStorage.getItem('brv-user-token') || localStorage.getItem('token') || '';
        return fetch(`${this.state.url}${idCorrida}/trajeto/`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                ...(token ? { 'Authorization': 'Token ' + token } : {})
            }
        });
    }
}
export default NovoEventoService;

